export class MakeCallInput {
  leadId: string;
}
